
export function unauthorized(response: Response) {
    if (response.headers.get('x-unauthorized') === 'true') {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname + window.location.search);
    }
    return response;
}
